module.exports = __webpack_public_path__ + "static/img/nengli3.a11fb1b1.png";